<template>
  <div>
    <wisdom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </wisdom-header>
    <div v-if="marketType == 'spread'"><market-spread></market-spread></div>
    <div v-if="marketType == 'channel'"><market-channel></market-channel></div>
    <div v-if="marketType == 'case'"><market-case></market-case></div>
    <div v-if="marketType == 'free'"><free-program></free-program></div>
    <column-tab v-if="marketType != 'free' && showTab" :type="marketType"></column-tab>
    <wisdom-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </wisdom-footer>
  </div>
</template>
<script>
import WisdomHeader from "@/components/pc/Header";
import MarketSpread from "@/components/pc/MarketSpread";
import MarketChannel from "@/components/pc/MarketChannel";
import FreeProgram from "@/components/pc/FreeProgram";
import ColumnTab from "@/components/pc/ColumnTab";
import MarketCase from "@/components/pc/MarketCase";
import WisdomFooter from "@/components/pc/Footer";
export default {
  name: "wisdomMarket",
  data() {
    return {
      marketType: "",
      actIndex: 2, //页码
      imgList: [], //轮播图
      logo: "", //logo
      bottomInfo: {}, //底部联系我们
      productType: [], //产品类别
      bottom: {}, //底部信息
      bottomNews: [],
      topStyle: "", //页样式
      titleObj: {},
      showTab: false,
    };
  },
  components: {
    WisdomHeader,
    MarketSpread,
    MarketChannel,
    MarketCase,
    ColumnTab,
    FreeProgram,
    WisdomFooter,
  },
  mounted() {
    this.marketType = this.$route.params.type;
    this.getPageData();
    window.addEventListener("scroll", this.handleScroll);
    switch (this.marketType) {
      case "case":
        this.titleObj = {
          title: "智慧案场",
          desc:
            "让房地产销售跳脱传统模式，不再受制于工程进度，将项目通过3D的方式提前呈现",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/product/top_case.png") +
          "')";
        break;
      case "spread":
        this.titleObj = {
          title: "智慧传播",
          desc: "专为企业打造官方营销入口，购房客户线上体验全面升级",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/product/top_spread.png") +
          "')";
        break;
      case "channel":
        this.titleObj = {
          title: "智慧渠道",
          desc: "人脸识别判客规则和百度人脸识别技术有效结合",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/product/top_channel.png") +
          "')";
        break;
      case "free":
        this.titleObj = {
          title: "免单节营销解决方案",
          desc: "狂欢免单，创造属于自己的城市营销解决方案",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/product/free_bg.png") +
          "')";
        break;
    }
  },
  watch: {
   
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_wisdomMarket/"+this.marketType);
      } else {
        this.$router.push("/wisdomMarket/"+this.marketType);
      }
    },
    getPageData() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/aboutPag", null, (res) => {
        // console.log(res.data)
        this.productType = res.data.type;
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 310) {
        this.showTab = true;
        // window.removeEventListener("scroll", this.handleScroll);
      } else {
        this.showTab = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/pc/WisdomMarket.vue